import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
export var AnnotationCreate = /*#__PURE__*/_createClass(function AnnotationCreate(annotationId, annotation) {
  _classCallCheck(this, AnnotationCreate);
  this.annotationId = annotationId;
  this.annotation = annotation;
});
export var AnnotationEdit = /*#__PURE__*/_createClass(function AnnotationEdit(annotationId, annotation) {
  _classCallCheck(this, AnnotationEdit);
  this.annotationId = annotationId;
  this.annotation = annotation;
});
export var AnnotationDelete = /*#__PURE__*/_createClass(function AnnotationDelete(annotationId) {
  _classCallCheck(this, AnnotationDelete);
  this.annotationId = annotationId;
});
export var AnnotationBatchUpsert = /*#__PURE__*/_createClass(function AnnotationBatchUpsert(annotations) {
  _classCallCheck(this, AnnotationBatchUpsert);
  this.annotations = annotations;
});
export var DocumentChanges = /*#__PURE__*/_createClass(function DocumentChanges(added, contentChanged, moved, removed) {
  _classCallCheck(this, DocumentChanges);
  this.added = added;
  this.contentChanged = contentChanged;
  this.moved = moved;
  this.removed = removed;
});
export var FormInputsChanges = /*#__PURE__*/_createClass(function FormInputsChanges(field, value) {
  _classCallCheck(this, FormInputsChanges);
  this.field = field;
  this.value = value;
});
export var DocumentUpdate = /*#__PURE__*/_createClass(function DocumentUpdate(container, documentId, changes) {
  _classCallCheck(this, DocumentUpdate);
  this.container = container;
  this.documentId = documentId;
  this.changes = changes;
});
